(() => {
  if (customElements.get('cabane-category-search')) return;

  // Some menu links omit navigation: match category expressions across every group.
  function categoryQuery(params, groups) {
    const current = params.get('q') || '';
    const preferred = groups[params.get('navigation')];
    const candidates = [preferred, ...Object.values(groups)].filter(Boolean).flatMap(group => [
      group.productQuery,
      ...(group.items || []).map(item => {
        const url = new URL(item.url || '/', location.origin);
        return url.pathname.endsWith('/search') ? url.searchParams.get('q') : '';
      })
    ]).filter(Boolean);
    return candidates.find(query => current === query) ||
      candidates.sort((a, b) => b.length - a.length)
        .find(query => current.startsWith('(' + query + ') AND ')) || '';
  }

  class CategorySearch extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else this.initialize();
    }
    initialize() {
      if (this.ready) return;
      const input = this.querySelector('input');
      if (!input) return;
      this.ready = true;
      const params = new URL(location.href).searchParams;
      const titleQuery = text => text.trim().split(/\s+/).filter(Boolean)
        .map(word => 'title:"' + word.replace(/[\\"]/g, '\\$&') + '"').join(' AND ');
      const currentQuery = params.get('q') || '';
      let baseQuery = this.dataset.bmxParts === 'true' ? this.dataset.bmxQuery : categoryQuery(params, window.CabaneCategoryNavigation?.groups || {});
      if (!baseQuery && /(?:^|[\s(])(?:tag|title|product_type|vendor):/i.test(currentQuery)) {
        baseQuery = currentQuery;
        const previous = params.get('category_search');
        const suffix = previous ? ') AND (' + titleQuery(previous) + ')' : '';
        if (suffix && currentQuery.startsWith('(') && currentQuery.endsWith(suffix)) {
          baseQuery = currentQuery.slice(1, -suffix.length);
        }
      }
      const generalSearch = !baseQuery && this.dataset.scope === 'all';
      const scopeQuery = baseQuery || (generalSearch ? '' : currentQuery);
      input.value = generalSearch ? params.get('q') || '' : params.get('category_search') ?? (this.dataset.bmxParts === 'true' ? input.value : '');
      const categoryLabel = params.get('category_label');
      if (!generalSearch && categoryLabel && this.dataset.bmxParts !== 'true') {
        requestAnimationFrame(() => {
          const heading = document.querySelector('main h1');
          if (heading) heading.textContent = categoryLabel;
          const emptyMessage = document.querySelector('.template-search__header p[role="status"]');
          if (emptyMessage) emptyMessage.textContent = document.documentElement.lang.startsWith('en') ? 'No matching products in this category.' : 'Aucun produit ne correspond dans cette catégorie.';
        });
      }
      const submit = () => {
        const text = input.value.trim();
        const target = new URL(location.href);
        const query = titleQuery(text);
        if (generalSearch) {
          target.searchParams.set('q', window.CabaneDiscoverySearch?.normalizeQuery(text) || text);
          for (const name of ['navigation', 'univers', 'category_search', 'category_label']) target.searchParams.delete(name);
        } else {
          target.searchParams.set('q', query ? '(' + scopeQuery + ') AND (' + query + ')' : scopeQuery);
          if (text) {
            target.searchParams.set('category_search', text);
            const label = categoryLabel || document.querySelector('main h1')?.textContent.trim();
            if (label && !/(?:tag|title|vendor|product_type):/i.test(label)) target.searchParams.set('category_label', label);
          } else {
            target.searchParams.delete('category_search');
            target.searchParams.delete('category_label');
          }
        }
        target.searchParams.set('type', 'product');
        target.searchParams.delete('page');
        location.assign(target.href);
      };
      input.addEventListener('input', event => event.stopPropagation());
      input.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        event.stopPropagation();
        submit();
      });
      input.addEventListener('search', () => { if (!input.value) submit(); });
      (this.querySelector('[data-inline-search-submit]') || this.querySelector('button'))?.addEventListener('click', submit);
      this.querySelector('[data-inline-search-clear]')?.addEventListener('click', () => {
        input.value = '';
        submit();
      });
    }
  }
  customElements.define('cabane-category-search', CategorySearch);
})();

